<template>
  <div class="doge-shell invest-record-page">
    <header class="doge-top"><button class="doge-back" @click="$router.back()">‹</button><h1 class="doge-title">资产日志</h1><div class="doge-placeholder"></div></header>
    <main class="invest-record-pad">
      <div v-for="r in records" :key="r.id" class="invest-card">
        <div class="invest-card-head"><b>{{ r.product && r.product.name || 'DOGE零钱罐' }}</b><span>{{ statusText(r) }}</span></div>
        <div class="invest-card-body">
          <img class="package-img" src="@/assets/img/package-icon-1.png" alt="package">
          <div class="invest-info-box">
            <div><span>{{ isJarTwo(r) ? "当前余额" : "金额" }}</span><b class="gold-text">{{ money(isJarTwo(r) ? r.compound_balance : r.principal) }}</b></div>
            <div><span>{{ isJarTwo(r) ? "每日递减释放" : "日收益" }}</span><b>{{ currentRateText(r) }}</b></div>
            <div><span>{{ isJarTwo(r) ? "累计已释放" : "收益" }}</span><b>{{ money(packageProfit(r)) }}U</b></div>
            <div><span>时间</span><b>{{ formatTime(r.first_buy_at || r.created_at) }}</b></div>
            <div v-if="!isJarTwo(r)"><span>{{ timeLabel(r) }}</span><b>{{ displayTime(r) }}</b></div>
          </div>
          <button v-if="r.status !== 3" class="end-invest-btn" :disabled="buttonDisabled(r)" @click="redeem(r)">{{ actionText(r) }}</button>
          <button v-else class="end-invest-btn disabled" disabled>已结束</button>
        </div>
      </div>
      <div v-if="!records.length" class="doge-empty">暂无购买记录</div>
    </main>
    <BottomNav/>
  </div>
</template>
<script>
import { formatRatePercent } from '../../utils/formatRate';
import BottomNav from '../../components/layout/BottomNav.vue';
export default {
  name: 'recordList',
  components: { BottomNav },
  data() { return { records: [], operating: null }; },
  mounted() { this.load(); },
  methods: {
    async load() { try { await this.$store.dispatch('ensureDogeAuth'); const r = await this.$axios.get('/api/doge/positions'); this.records = (r.data.data && r.data.data.data) || r.data.data || []; } catch (e) { this.records = []; } },
    isJarTwo(r) { return Number(r.product_type) === 2; },
    currentRateText(r) {
      const rate = r.product && (this.isJarTwo(r) ? r.product.release_rate : r.product.daily_rate);
      return rate == null || rate === '' ? '--' : this.percent(rate);
    },
    async redeem(r) {
      if (this.isJarTwo(r)) return this.$router.push({ name: 'buyPage', params: { packageId: r.doge_product_id }, query: { position_id: r.id } });
      this.operating = r.id;
      try {
        const canOut = this.canTransferOut(r);
        if (this.isLockedPeriod(r)) return this.msg('固定收益期间暂不能提取，请到提取期间再操作');
        if (Number(r.status) === 2 && !canOut) return this.msg('结束申请已提交，请等到可转出时间再操作');
        const url = canOut ? '/api/doge/transfer_out' : '/api/doge/request_redeem';
        await this.$store.dispatch('ensureDogeAuth');
        const res = await this.$axios.post(url, { position_id: r.id });
        if (res.data.code && ![1, 200].includes(Number(res.data.code))) throw new Error(res.data.message || res.data.msg);
        this.msg(canOut ? '转出成功，金额已回到可用余额' : '申请已提交，请等到可转出时间再操作');
        this.load();
      } catch (e) {
        this.msg(this.friendlyError((e.response && e.response.data && (e.response.data.message || e.response.data.msg)) || e.message || '操作没有成功，请稍后再试'));
      } finally {
        this.operating = null;
      }
    },
    friendlyError(message) {
      const text = String(message || '');
      if (/固定收益|固定期间|到期|not time|transfer-out|可转出时间/i.test(text)) return '固定收益期间暂不能提取，请到提取期间再操作';
      if (/当前不在|转出窗口|还未到|not currently/i.test(text)) return '还没到提取时间，请稍后再来操作';
      if (/可转出金额为0|amount.*0/i.test(text)) return '当前没有可转出的金额';
      if (/资产包已结束|closed/i.test(text)) return '这笔投资已经结束了';
      return text || '操作没有成功，请稍后再试';
    },
    boolValue(v) { return Number(v) === 1 || v === true; },
    parseServerTime(v) {
      if (!v) return null;
      const raw = String(v).trim();
      const date = new Date(/[zZ]$|[+-]\d{2}:?\d{2}$/.test(raw) ? raw.replace(' ', 'T') : raw.replace(' ', 'T') + '+08:00');
      return Number.isNaN(date.getTime()) ? null : date;
    },
    isLockedPeriod(r) {
      if (this.isJarTwo(r)) return false;
      if (this.boolValue(r.is_locked_period)) return true;
      if (Number(r.status) !== 1 || this.boolValue(r.is_grace_period) || this.canTransferOut(r)) return false;
      const availableAt = this.parseServerTime(r.matured_transfer_available_at);
      return availableAt ? new Date() < availableAt : false;
    },
    canTransferOut(r) { return this.boolValue(r.can_transfer_out); },
    buttonDisabled(r) { if (this.isJarTwo(r)) return this.operating === r.id || Number(r.status) !== 1; return this.operating === r.id || this.isLockedPeriod(r) || (Number(r.status) === 2 && !this.canTransferOut(r)); },
    actionText(r) { if (this.isJarTwo(r)) return '转入'; if (this.operating === r.id) return '处理中...'; if (this.isLockedPeriod(r)) return '提取期可转出'; if (Number(r.status) === 2 && !this.canTransferOut(r)) return '等待可转出'; return this.canTransferOut(r) ? '确认转出' : '申请结束'; },
    statusText(r) { if (this.isJarTwo(r)) return Number(r.status) === 3 ? '已结束' : '递减释放中'; if (this.isLockedPeriod(r)) return '固定收益中'; if (Number(r.status) === 2) return this.canTransferOut(r) ? '可转出' : '等待可转出'; return { 1: '进行中', 3: '已结束' }[Number(r.status || 1)] || '进行中'; },
    timeLabel(r) { if (this.isLockedPeriod(r)) return '提取时间'; if (Number(r.status) === 2) return this.canTransferOut(r) ? '提取截止' : '可转出时间'; return Number(r.status) === 3 ? '结束时间' : '时间'; },
    displayTime(r) { if (this.isLockedPeriod(r)) return this.formatTime(r.matured_transfer_available_at); if (Number(r.status) === 2) return this.formatTime(this.canTransferOut(r) ? (r.redeem_expired_at || r.updated_at) : (r.redeem_available_at || r.updated_at)); return this.formatTime((r.first_buy_at || r.created_at || r.updated_at)); },
    packageProfit(r) { if (this.isJarTwo(r)) return Number(r.total_static_profit || 0); return Math.max(0, Number(r.compound_balance || 0) - Number(r.principal || 0)); },
    money(v) { return Number(v || 0).toFixed(2); },
    percent: formatRatePercent,
    formatTime(v) {
      if (!v) return '--';
      const raw = String(v).trim();
      let value = raw.replace(' ', 'T');
      value = value.replace(/\.\d+Z?$/, 'Z');
      if (!/[zZ]$|[+-]\d{2}:?\d{2}$/.test(value)) value += 'Z';
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return raw.replace('T', ' ').replace(/\.\d+Z?$/, '').replace(/Z$/, '').slice(0, 16);
      const parts = new Intl.DateTimeFormat('zh-CN', {
        timeZone: 'Asia/Shanghai',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hour12: false
      }).formatToParts(date).reduce((acc, part) => {
        acc[part.type] = part.value;
        return acc;
      }, {});
      return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}`;
    },
    msg(t) { this.$messageDialog ? this.$messageDialog.alert(t, '提示', 'info') : alert(t); }
  }
};
</script>
<style scoped>
.invest-record-page{background:#f7f8f8}.invest-record-pad{padding:18px 20px 78px}.invest-card{background:#eef0f0;border-radius:2px;margin-bottom:20px;overflow:hidden;box-shadow:0 2px 8px rgba(0,0,0,.025)}.invest-card-head{height:48px;background:linear-gradient(180deg,#dfaa2e 0%,#ecca62 100%);display:flex;align-items:center;justify-content:space-between;padding:0 22px;color:#fff}.invest-card-head b{font-size:15px;font-weight:700;color:#4c3b13}.invest-card-head span{font-size:13px;color:#fff;font-weight:700}.invest-card-body{padding:20px 16px 22px;text-align:center}.package-img{width:116px;height:116px;object-fit:contain;margin:0 auto 12px;display:block}.invest-info-box{background:#fff;border-radius:0;padding:12px 18px;margin:0 auto;color:#9b9b9b;text-align:left}.invest-info-box div{display:grid;grid-template-columns:88px 1fr;gap:10px;align-items:center;min-height:24px;font-size:12px}.invest-info-box span{color:#9a9a9a}.invest-info-box b{color:#1f1f1f;font-weight:500;text-align:right;font-size:12px;word-break:break-all}.invest-info-box .gold-text{color:#e1bd54;font-size:17px;font-weight:700}.end-invest-btn{margin-top:13px;min-width:72px;height:24px;border:0;border-radius:4px;background:#d8a43d;color:#fff;font-size:12px;font-weight:700;padding:0 12px}.end-invest-btn.disabled,.end-invest-btn:disabled{background:#d9d1c2;color:#fff}.doge-empty{background:#fff;border-radius:16px;margin-top:20px}
</style>
